export const getEngineReportRoute = (vesselId: string, reportId: string): string[] => {
  return ['site', vesselId, 'engine-reports', reportId];
};
